module.exports = __webpack_public_path__ + "media/images/flags/64/Chad-059916207352485bf1f536e36f61ce51.png";